/**
 * Four-Column Feature Grid Validation
 * Enforces character limits to prevent content overflow
 */

(function () {
  "use strict";

  const LIMITS = {
    title: 40,
    description: 400,
  };

  // Initialize validation when in Shopify theme editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function (event) {
      initValidation(event.detail.sectionId);
    });

    // Initialize on page load
    document.addEventListener("DOMContentLoaded", function () {
      initValidation();
    });
  }

  function initValidation(sectionId) {
    // This runs in the theme editor context
    // Add validation listeners for title and description inputs
    const section = sectionId
      ? document.querySelector(`[data-section-id="${sectionId}"]`)
      : document.querySelector(".two-note-four-col");

    if (!section) return;

    // Monitor for content changes and validate
    validateContent(section);

    // Set up mutation observer to catch content changes
    const observer = new MutationObserver(function () {
      validateContent(section);
    });

    observer.observe(section, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function validateContent(section) {
    const columns = section.querySelectorAll(".two-note-four-col__column");
    let hasErrors = false;

    columns.forEach(function (column) {
      const title = column.querySelector(".two-note-four-col__title");
      const description = column.querySelector(".two-note-four-col__desc");

      if (title) {
        const titleText = title.textContent.trim();
        if (titleText.length > LIMITS.title) {
          hasErrors = true;
          markFieldAsError(title, "title", titleText.length);
        } else {
          clearFieldError(title);
        }
      }

      if (description) {
        const descText = description.textContent.trim();
        if (descText.length > LIMITS.description) {
          hasErrors = true;
          markFieldAsError(description, "description", descText.length);
        } else {
          clearFieldError(description);
        }
      }
    });

    // Show validation summary if errors exist
    if (hasErrors && window.Shopify && window.Shopify.designMode) {
      showValidationError(section);
    } else {
      clearValidationError(section);
    }
  }

  function markFieldAsError(element, fieldType, length) {
    element.classList.add("character-limit-exceeded");
    element.setAttribute(
      "data-error",
      `Exceeds ${LIMITS[fieldType]} character limit (${length} characters)`,
    );
  }

  function clearFieldError(element) {
    element.classList.remove("character-limit-exceeded");
    element.removeAttribute("data-error");
  }

  function showValidationError(section) {
    let errorBanner = section.querySelector(".validation-error-banner");

    if (!errorBanner) {
      errorBanner = document.createElement("div");
      errorBanner.className = "validation-error-banner";
      errorBanner.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        background: #d72c0d;
        color: white;
        padding: 16px;
        text-align: center;
        font-family: var(--font-body);
        font-size: 14px;
        z-index: 10000;
        font-weight: 500;
      `;
      errorBanner.innerHTML = `
        <strong>⚠ Character Limit Exceeded</strong><br>
        Title: Max ${LIMITS.title} characters | Description: Max ${LIMITS.description} characters<br>
        <em>Please reduce content length to save changes.</em>
      `;
      document.body.prepend(errorBanner);
    }
  }

  function clearValidationError(section) {
    const errorBanner = document.querySelector(".validation-error-banner");
    if (errorBanner) {
      errorBanner.remove();
    }
  }

  // Frontend validation for non-editor view
  function validateFrontend() {
    const sections = document.querySelectorAll(".two-note-four-col");

    sections.forEach(function (section) {
      const titles = section.querySelectorAll(".two-note-four-col__title");
      const descriptions = section.querySelectorAll(".two-note-four-col__desc");

      titles.forEach(function (title) {
        const text = title.textContent.trim();
        if (text.length > LIMITS.title) {
          title.textContent = text.substring(0, LIMITS.title) + "...";
        }
      });

      descriptions.forEach(function (desc) {
        const text = desc.textContent.trim();
        if (text.length > LIMITS.description) {
          desc.textContent = text.substring(0, LIMITS.description) + "...";
        }
      });
    });
  }

  // Run frontend validation on page load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", validateFrontend);
  } else {
    validateFrontend();
  }
})();
